import classNames from "classnames/bind";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import Button from "../../../components/Button/Button";
import { useStoreContext } from "../../../hooks/useStoreContext";
import axiosClient from "../../../services/axiosClient";
import HeaderRegister from "../HeaderRegister";
import InputGroup from "../InputGroup";
import styles from './RegisterVerifyContainer.module.css';
import PropTypes from "prop-types";
import Clock from "./Clock";
import ErrorNotify from "./ErrorNotify";
import axios from "axios";
import { actions } from "../../../store";
import { Input } from "antd";

const cx = classNames.bind(styles);

function RegisterVerifyContainer({ header, back, register, forgotPass, getError }) {
    // eslint-disable-next-line
    const [dataUser, dispatch] = useStoreContext()
    const [code, setCode] = useState('')
    const [error, setError] = useState(false)
    const [reGetOTP, setReGetOTP] = useState(false)
    const [reFreshTime, setReFreshTime] = useState(false)
    const [count, setCount] = useState(0)
    const baseUrl = process.env.REACT_APP_API_URL;
    const navigate = useNavigate()
    const handleChangeCode = (data) => {
        if (data && data.trim().length === 6) {
            setCode(data)
            setError(false)
        }
        else (
            setError(true)
        )
    }

    const handleSubmitCode = (code) => {
        if (!code && code?.trim().length === 0) {
            setError(true)
        } else {
            if (count > 5) {
                getError('Đã có lỗi xảy ra')
            } else {
                setCount(count + 1)
                if (!error) {
                    if (register) {
                        const createAcount = async () => {
                            try {
                                const res = await axios.post(`${baseUrl}/authenticator/verifyAccount/`, {
                                    token: dataUser.tokenUser,
                                    code: code
                                })
                                navigate('/register/verify-token/succes')
                                return res
                            } catch (error) {
                                setError(true)
                                getError('Mã của bạn không đúng')
                            }
                        }
                        createAcount()
                    }
                    if (forgotPass) {
                        const getVerifyToken = async () => {
                            try {
                                const res = await axiosClient.post('/authenticator/password-reset/validate-token', {
                                    token: code,
                                    username: dataUser.emailForgotPassword
                                })
                                dispatch(actions.setTokenUser(code))
                                navigate('/forgot-password/change-password')
                                return res
                            } catch (error) {
                                getError('Mã của bạn không đúng')
                            }
                        }
                        getVerifyToken()
                    }
                }
            }
        }

    }

    const onTimeOut = (data) => {
        setReGetOTP(data)
    }

    const handleReGetOTP = async () => {
        setReGetOTP(!reGetOTP)
        setReFreshTime(!reFreshTime)
        if (forgotPass) {
            try {
                const token = await axiosClient.post('/authenticator/password-reset/require', { email: dataUser.emailForgotPassword })
                return token;
            } catch (error) {
                setError(true)
            }
        } else {
            getError('Tạm thời chưa thể gửi lại OTP')
        }
    }

    const onChange = (text) => {
        handleSubmitCode(text);
    };

    const onInput = (value) => {
        setCode(value?.join(''));
    };

    const sharedProps = {
        onChange,
        onInput,
    };

    return (
        <>
            <HeaderRegister backTo={back} header={header} />
            {count === 5 ? <><ErrorNotify backTo={back} /></> : <> <div className={cx('register-verify')}>
                {!error ?
                    <p className={cx('title')}>Một mã 6 ký tự đã được gửi về địa chỉ email của bạn</p> :
                    <p className={cx('title', 'error')}>Mã xác thực chỉ chứa các ký tự số</p>
                }
                {/* <InputGroup onGetCode={handleSubmitCode} error={error} />
                 */}
                <div className={cx('input-otp')}>
                    <Input.OTP {...sharedProps} />
                </div>
                <Clock minutes={10} getTimeOut={onTimeOut} isReFresh={reFreshTime} />
                <div className={cx('submit-button')}>
                    <button className={cx('submit-button')}>
                        <Button
                            title="Tiếp tục"
                            onClick={() => handleSubmitCode(code)}
                        />
                    </button>
                    {
                        reGetOTP && <button className={cx('refresh-code-btn')} onClick={handleReGetOTP}>
                            Gửi lại
                        </button>
                    }
                </div>
            </div></>
            }
        </>
    )
}

RegisterVerifyContainer.propTypes = {
    header: PropTypes.string,
    back: PropTypes.string,
    register: PropTypes.bool,
    forgotPass: PropTypes.bool,
}

export default RegisterVerifyContainer;